export interface ISeasonStanding {
  cash: number;
  clubId: number;
  eventId: number;
  eventName: string;
  grossScore: number;
  handicap: number;
  netScore: number;
  points: number;
  script: number;
  seasonId: number;
  userFirstName: string;
  userId: number;
  userImage: string;
  userLastName: string;
}

export interface ISeasonEventStanding extends ISeasonStanding {
  roundId: number;
  roundOrder: number;
}

export interface IStandingsStore {
  byClub: { [clubId: number]: ISeasonStanding[] };
  byEvent: { [eventId: number]: ISeasonEventStanding[] };
  bySeason: { [seasonId: number]: ISeasonStanding[] };
}

export const standingsStore = { byClub: {}, byEvent: {}, bySeason: {} };
